/** Copyright © 2013-2023 DataYes, All Rights Reserved. */

import 'antd/dist/antd.css';
import { css } from 'styled-components';

const HEADER = '#e1f1ff';
const BORDER = '#d9e7f4';
const ROW = '#f3f9ff';
const ROW_HOVER = '#d3eaff';

export const tableCss = css`
  .ant-empty {
    margin: 50px 0;
  }
  .ant-table {
    table {
      border-radius: 0;
    }

    .ant-table-thead > tr > th {
      border-radius: 0;
      height: 30px;
      white-space: nowrap;
      border-bottom: 1px solid ${BORDER} !important;
      padding: 5px 8px !important;
    }
    .ant-table-tbody > tr > td {
      border-radius: 0;
      height: 30px;
      white-space: nowrap;
      border-bottom: 1px solid ${BORDER} !important;
      padding: 3px 8px !important;
    }

    .ant-table-tbody > tr.ant-table-measure-row > td {
      padding: 0 8px !important;
    }

    .ant-table-thead > tr > th {
      background-color: ${HEADER} !important;
      border-color: ${BORDER} !important;

      .ant-table-column-sorter {
        margin-top: -10px;
      }

      &.ant-table-column-has-actions:hover {
        .ant-table-filter-icon {
          background: #e1f1ff;
        }
      }

      .ant-table-column-sorters:hover:before {
        background: rgba(211, 234, 255, 0.04);
      }

      .ant-table-filter-icon.icon-filter {
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          background: #d3eaff;
        }
      }
    }

    .ant-table-tbody {
      > tr:nth-child(even) > td {
        background-color: ${ROW};
      }

      > tr.table-summary-data > td {
        background-color: #e5f0fe;
      }

      tr.ant-table-row-hover,
      > tr:hover {
        td {
          background-color: ${ROW_HOVER};
        }
      }
    }

    &-bordered {
      font-size: 12px;

      .ant-table-header > table,
      .ant-table-body > table,
      .ant-table-fixed-left > table,
      .ant-table-fixed-right > table {
        border-color: ${BORDER} !important;
      }

      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        height: 26px;
        border-right: 1px solid ${BORDER} !important;
      }
    }
  }
  .ant-pagination {
    text-align: center;
    position: relative;
    margin-left: 0px !important;
    font-size: 12px;
    margin-top: 20px;
    .ant-pagination-total-text {
      position: absolute;
      left: 0;
      background: #fff;
      padding-right: 5px;
      height: 21px;
      line-height: 21px;
    }
    &.mini .ant-pagination-item {
      margin: 0;
      min-width: 18px;
      height: 18px;
      line-height: 19px;
      border: none;
    }
    .ant-pagination-item-active {
      background: #1283d5;
      a {
        color: #fff;
      }
    }
    .ant-pagination-options-quick-jumper {
      input {
        height: 18px;
      }
    }
    &.mini .ant-pagination-options-quick-jumper {
      input {
        height: 18px;
      }
    }
  }
`;

export const tabCss = css`
  .ant-tabs.ant-tabs-card {
    font-family: inherit;

    > .ant-tabs-bar {
      .ant-tabs-tab {
        border-radius: 6px 6px 0 0;
        padding-top: 2px;
        line-height: 27px !important;
        border-color: ${BORDER};
        background: #f7f7f7;
        font-size: 14px;
        color: #666;
        /*-- 悬停按钮效果 --*/
        &:hover {
          color: #44a2e6;
          border-color: #44a2e6;
        }
      }
      .ant-tabs-tab-active {
        background: #fff;
        color: #1283d5;
        padding-bottom: 2px;
      }
      .ant-tabs-nav-container {
        height: 32px !important;
      }
    }

    > .ant-tabs-nav {
      height: 32px;

      .ant-tabs-tab {
        padding: 0 10px;
      }
    }
  }
  /* tabs-line 『<Tabs>xxx</Tabs>』 视觉规范 */
  .ant-tabs-line {
    & > .ant-tabs-bar {
      & > .ant-tabs-nav-container {
        & > .ant-tabs-nav-wrap {
          & > .ant-tabs-nav-scroll {
            .ant-tabs-nav {
              .ant-tabs-tab {
                margin: 0 32px 0 0;
                padding: 4px 9px;
              }
              & > .ant-tabs-tab-active {
                color: #1283d5;
                font-weight: normal;
              }
            }
          }
        }
      }
    }
  }
`;

export const inputCss = css`
  .ant-input,
  .ant-input-number {
    border-color: #e9e9e9;
  }
  .ant-input-affix-wrapper {
    border-color: #e9e9e9;
  }
`;

export const selectCss = css`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: #e9e9e9;
  }
`;

export const modalCss = css`
  .ant-modal-body {
    padding-bottom: 0;
  }
  .ant-modal-footer {
    border: none;
    padding: 0 20px 20px;

    > .ant-btn:not(:first-of-type) {
      margin-left: 20px;
    }
  }
`;

export const pickerCss = css`
  .ant-picker,
  .ant-picker.ant-picker-disabled {
    border-color: #e9e9e9;
  }
`;

export const formWarningCss = css`
  .ant-form-item-has-error {
    // components/create-edit/image-upload的标红
    .image-upload-list .list-container {
      border-color: #ff4d4f;
    }
  }
`;
